import { useRef } from 'react';

// Spread onto a modal backdrop: closes only when both the press and the
// release land on the backdrop itself, so drag-selecting text inside the
// modal and releasing outside it doesn't dismiss it.
export default function useOverlayClose(onClose) {
  const pressedOnBackdrop = useRef(false);
  return {
    onMouseDown: e => { pressedOnBackdrop.current = e.target === e.currentTarget; },
    onClick: e => {
      if (pressedOnBackdrop.current && e.target === e.currentTarget) onClose();
      pressedOnBackdrop.current = false;
    },
  };
}
